"use client";

import { usePathname } from "next/navigation";
import { content } from "@/config/content";
import { useSiteSettings } from "@/lib/useSiteSettings";

function InstagramIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function FloatingIG() {
  const pathname = usePathname();
  const { settings } = useSiteSettings("brand");
  if (pathname.startsWith("/admin")) return null;

  const brandIgUrl = settings.brand_ig_url || content.brand.igUrl;

  return (
    // a11y fix (axe: region/landmark-one-main — floating link must be inside a landmark):
    // wrap the Instagram link in <aside role="complementary"> so screen readers can
    // locate it via landmark navigation.
    // data-floating-ig: 2026-10 結帳表單開著時由 globals.css 藏起來(lib/checkoutChrome.js)
    <aside role="complementary" aria-label="社群媒體連結" data-floating-ig="">
      <a
        href={brandIgUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="追蹤 Instagram"
        className="fixed z-50 flex items-center justify-center transition-transform hover:scale-105 active:scale-95"
        style={{
          /* ThemeSwitcher: bottom-4 (16px), ~44px tall → IG sits above it with 12px gap */
          bottom: "calc(16px + 44px + 12px + var(--safe-area-bottom))",
          right: "16px",
          width: "48px",
          height: "48px",
          color: "#fff",
          background: "linear-gradient(135deg, #833AB4, #E1306C, #F77737)",
          borderRadius: "50%",
          boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
        }}
      >
        <InstagramIcon />
      </a>
    </aside>
  );
}
